export default function WhoWeServe() {
  return (
    <section id="who-we-serve" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Who We Serve
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Helping local stores sell more snacks and helping producers reach more shelves.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 lg:gap-16">
          <div className="bg-gray-50 p-10 rounded-lg">
            <div className="w-16 h-16 bg-gray-900 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-store-2-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Independent Retail Stores
            </h3>
            <p className="text-base text-gray-700 leading-relaxed">
              We help independent stores bring in better snack products without managing inventory. We start with small placements to see what sells, handle shelf rotation and restocking, and expand the products that move. No large upfront commitments—just products that sell and margins that make sense.
            </p>
          </div>

          <div className="bg-gray-50 p-10 rounded-lg">
            <div className="w-16 h-16 bg-gray-900 rounded-lg flex items-center justify-center mb-6">
              <i className="ri-plant-line text-3xl text-white"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Local Producers
            </h3>
            <p className="text-base text-gray-700 leading-relaxed">
              Getting your products into stores is only the first step. We handle placement, restocking, and shelf management so your products stay visible and selling. Our focused Sonoma County route helps local producers reach more stores without building their own distribution operation.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}